import { Section } from "../types";
import {
  getSupplementalId,
  showWhenSupplementalDistrictHeatingCondition,
} from "../supplemental-heating.util";

export function supplementalDistrictHeatingLccSections(
  techPrefix: string
): Section[] {
  const id = (districtHeadingParameterId: string) =>
    getSupplementalId(techPrefix, districtHeadingParameterId);

  return [
    {
      title: "Flöde fjärrvärmespets",
      parameters: [id("DistrictHeatingFlowVolume")],
      conditions: [showWhenSupplementalDistrictHeatingCondition],
    },
    {
      title: "Investeringskostnad fjärrvärmespets",
      parameters: [
        id("DistrictHeatingCentralCost"),
        id("DistrictHeatingConnectionCost"),
        id("DistrictHeatingInvestmentLCCost"),
      ],
      conditions: [
        showWhenSupplementalDistrictHeatingCondition,
        { parameter: "DistrictHeatingInstalled", value: false },
      ],
    },
    {
      title: "Reinvesteringskostnad fjärrvärmespets",
      parameters: [
        id("DistrictHeatingReinvestmentCost"),
        id("DistrictHeatingReinvestmentPeriod"),
      ],
      conditions: [showWhenSupplementalDistrictHeatingCondition],
    },
    {
      title: "Drift- och underhållskostnader fjärrvärmespets",
      parameters: [id("DistrictHeatingMaintenanceCost")],
      conditions: [showWhenSupplementalDistrictHeatingCondition],
    },
  ];
}

export function supplementalDistrictHeatingCostSummaryLccSections(
  prefix: string
): Section[] {
  const id = (districtHeadingParameterId: string) =>
    getSupplementalId(prefix, districtHeadingParameterId);

  return [
    {
      title: "Livscykelkostnad fjärrvärmespets",
      parameters: [
        id("DistrictHeatingInvestmentLCCost"),
        id("DistrictHeatingMaintenanceLCCost"),
        id("DistrictHeatingEnergyLCCost"),
        id("DistrictHeatingLoadLCCost"),
        id("DistrictHeatingFlowLCCost"),
        id("DistrictHeatingReinvestmentLCCost"),
      ],
      conditions: [showWhenSupplementalDistrictHeatingCondition],
    },
  ];
}
